$(() => {
  // Define these changes separately because we only want them to fire when product options
  // are clicked. We don't want them firing on every pageload.
  const toggle_dependencies = () => {
    const fade = 400;
    const psv = $('#product-psv-checkbox');
    const pes = $('#product-pes-checkbox');

    if (psv.is(':checked') && pes.is(':checked')) {
      $('.impact-comma').slideDown();
    } else {
      $('.impact-comma').slideUp();
    }

    const dependencies = [
      // User inputs
      { element: $('#practitioners-for-enrollment-wrapper'), checkboxes: [pes] },
      { element: $('#payer-enrollment-timeline-wrapper'), checkboxes: [pes] },
      { element: $('#practitioners-for-initial-credential-wrapper'), checkboxes: [psv] },
      { element: $('#practitioners-for-recredential-wrapper'), checkboxes: [psv] },
      { element: $('#credentialing-psv-timeline-wrapper'), checkboxes: [psv] },

      // Benchmark inputs
      { element: $('#fte-doing-credentialing-wrapper'), checkboxes: [psv] },
      { element: $('#fte-doing-enrolling-wrapper'), checkboxes: [pes] },
      { element: $('#fte-doing-recredentialing-wrapper'), checkboxes: [psv] },

      // Benefits
      { element: $('.reduce-time-credentialing'), checkboxes: [psv] },
      { element: $('.reduce-time-enrolling'), checkboxes: [pes] },
      { element: $('.reduce-time-recredentialing'), checkboxes: [psv] },
      { element: $('.increase_revenue_benefit'), checkboxes: [psv] },
      { element: $('.psv-impact'), checkboxes: [psv] },
      { element: $('.percent-rdxn-pev-time'), checkboxes: [pes] },
      { element: $('.pes-impact'), checkboxes: [pes] },

      // Benefit details
      { element: $('.benefit-detail-pes'), checkboxes: [pes] },
      { element: $('.benefit-detail-psv'), checkboxes: [psv] },

      // Impacts
      { element: $('.psv-impact'), checkboxes: [psv] },
      { element: $('.pes-impact'), checkboxes: [pes] },

      // Investment
      { element: $('#psv-license-fee-wrapper'), checkboxes: [psv] },
      { element: $('#pes-license-fee-wrapper'), checkboxes: [pes] },
    ];

    dependencies.forEach((dependency) => {
      const checked = dependency.checkboxes.filter(($checkbox) => $checkbox.is(':checked'));

      if (checked.length > 0) {
        dependency.element.slideDown(fade);
      } else {
        dependency.element.slideUp(fade);
      }
    });
  };

  $('.product-options').click(() => {
    toggle_dependencies();
  });

  toggle_dependencies();
});
